// extracted by mini-css-extract-plugin
module.exports = {"option":"Option_option__3fBM4","label":"Option_label__1-cP2"};